import styled, { css } from 'styled-components'

import { maxmedia, minmedia } from '../../styles/media-queries'
import { white, black, red, inputgray, almostblack } from '../../styles/colors'

export const InputContainer = styled.div`
  width: 100px; //InputWrapper only
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;


  ${props =>
    props.end &&
    css`
     width: 200px;   
  `};

  ${minmedia.medium`
    width: 180px; //35+35+75=145
    justify-content: space-between;
    margin: 0 auto;

  ${props =>
    props.end &&
    css`
      justify-content: flex-end;   
      width: 200px;
  `};
  `} ${minmedia.large`
    width: 215px; //35+35+100=170

    ${props =>
      props.end &&
      css`
       width: 200px;   
    `};
  `};
  
`

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${white};
  opacity: 0.5;
`

export const Button = styled.div`
  transition: all 0.5s;
  width: 35px;
  height: 35px;
  border-radius: 100%;
  border: 1px solid ${black};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  font-weight: 300;
  cursor: pointer;
  color: ${black};

  &:hover {
    background: ${red};
    color: ${white};
    border: 1px solid ${red};
  }
  span {
    margin-top: -3px;
    user-select: none;
  }

  &.plus {
  }

  ${maxmedia.medium`
    display: none;
  `};
`

export const PlusButton = Button.extend`
  background: ${red};
  border-color: ${red};
  color: ${white};

  &:hover {
    background: ${almostblack};
    color: ${white};
    border: 1px solid ${almostblack};
  }
`

export const EmptySquare = styled.div`
  width: 35px;
  height: 35px;
`

export const StyledInput = styled.input`
  border: 0;
  width: calc(100% - 20px);
  padding: 0;
  font-size: 14px;
  text-align: right;
  background: none;
  &:focus {
    outline: none;
  }
`

export const InputCol = styled.div`
  width: 100px;
`

export const StyledLabel = styled.div`
  font-size: 14px;
  margin-bottom: 0.5rem;
  padding-left: 0.25rem;
`


export const StyledSelect = styled.select`
  width: 100%;
  appearance: none;
  box-sizing: border-box;
  padding: 0.25rem 1rem;
  min-height: 35px; //match search input

  font-size: 16px;
  text-transform: lowercase;
  border: 1px solid ${black};
  border-right: 0;
  border-radius: 2.5rem;

  background-color: ${white};
  background-image: url(${props => props.chevron});
  background-position: calc(100% - 14px) center;
  background-repeat: no-repeat;
  background-size: 15px 15px;

  border-top-right-radius: 0;   
  border-bottom-right-radius: 0;   

  &:focus {
    border: 1px solid ${inputgray};
    box-shadow: 0px 0px 5px 0px ${inputgray};
    outline: none;
  }

  &::-ms-expand {
    display: none;
  }
`

export const SmallDescription = styled.div`
  width: 200px;
  font-size: 14px;
  font-style: italic;
  margin-top: 0.5rem;
  align-self: flex-start;
  text-transform: lowercase;
  text-align: center;
`

export const SmallDescriptionRight = styled.div`
  width: 130px;
  font-size: 11px;
  font-style: italic;
  margin-top: 0.5rem;
  align-self: flex-start;
  text-align: right;
`

export const InputWrapper = styled.div`
  width: 100%;
  border: 1px solid ${black};
  border-radius: 2.5rem;
  height: 35px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0.5rem;

  ${props =>
    props.dropdown &&
    css`
    border-top-left-radius: 0;   
    border-bottom-left-radius: 0;   
  `};

  ${minmedia.large`
    width: 100px;
  `};
`

export const Placeholder = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: ${inputgray};
`



// WEBPACK FOOTER //
// ./src/components/OrderInput/styles.js